var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _g, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToursImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1107,
    height: 262,
    viewBox: "0 0 1107 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M885 75L885 168.5L885 262",
    stroke: "url(#paint0_linear_2013_280)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M666 75L666 168.5L666 262",
    stroke: "url(#paint1_linear_2013_280)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445 75L445 168.5L445 262",
    stroke: "url(#paint2_linear_2013_280)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222 75L222 168.5L222 262",
    stroke: "url(#paint3_linear_2013_280)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 249.937V162.762V162.762C1.83612 114.051 41.563 75 90.2818 75H554.253H1014.71C1065.13 75 1106 115.873 1106 166.293V166.293V262",
    stroke: "url(#paint4_linear_2013_280)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 498.515,
    y: 17.548,
    width: 109.962,
    height: 109.032,
    rx: 54.516,
    fill: "url(#paint5_linear_2013_280)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 498.515,
    y: 17.548,
    width: 109.962,
    height: 109.032,
    rx: 54.516,
    stroke: "#CB97FF",
    strokeWidth: 1.40385
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.058 81.6945L553.496 94.2687L531.933 81.6945C531.506 81.4819 531.014 81.44 530.558 81.5773C530.101 81.7147 529.714 82.0208 529.475 82.4336C529.236 82.8464 529.163 83.3346 529.271 83.7991C529.38 84.2635 529.661 84.6692 530.058 84.9336L552.558 98.0586C552.845 98.2257 553.171 98.3138 553.503 98.3138C553.835 98.3138 554.16 98.2257 554.447 98.0586L576.947 84.9336C577.163 84.8113 577.353 84.6473 577.505 84.4511C577.657 84.255 577.769 84.0305 577.834 83.7908C577.899 83.5512 577.915 83.301 577.883 83.0548C577.85 82.8087 577.769 82.5715 577.644 82.357C577.518 82.1425 577.352 81.955 577.154 81.8054C576.956 81.6558 576.73 81.547 576.489 81.4853C576.249 81.4237 575.998 81.4104 575.753 81.4463C575.507 81.4822 575.271 81.5666 575.058 81.6945Z",
    fill: "url(#paint6_linear_2013_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.058 70.4445L553.496 83.0187L531.933 70.4445C531.506 70.2319 531.014 70.19 530.558 70.3273C530.101 70.4647 529.714 70.7709 529.475 71.1836C529.236 71.5964 529.163 72.0846 529.271 72.5491C529.38 73.0135 529.661 73.4192 530.058 73.6836L552.558 86.8086C552.845 86.9757 553.171 87.0638 553.503 87.0638C553.835 87.0638 554.16 86.9757 554.447 86.8086L576.947 73.6836C577.163 73.5613 577.353 73.3973 577.505 73.2011C577.657 73.005 577.769 72.7805 577.834 72.5408C577.899 72.3012 577.915 72.051 577.883 71.8048C577.85 71.5587 577.769 71.3215 577.644 71.107C577.518 70.8925 577.352 70.705 577.154 70.5554C576.956 70.4058 576.73 70.297 576.489 70.2353C576.249 70.1737 575.998 70.1604 575.753 70.1963C575.507 70.2323 575.271 70.3166 575.058 70.4445Z",
    fill: "url(#paint7_linear_2013_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.058 62.4336L552.558 75.5586C552.845 75.7257 553.171 75.8138 553.503 75.8138C553.834 75.8138 554.16 75.7257 554.447 75.5586L576.947 62.4336C577.23 62.2684 577.465 62.032 577.628 61.7478C577.791 61.4637 577.877 61.1417 577.877 60.814C577.877 60.4863 577.791 60.1644 577.628 59.8802C577.465 59.596 577.23 59.3596 576.947 59.1945L554.447 46.0695C554.16 45.9023 553.834 45.8142 553.503 45.8142C553.171 45.8142 552.845 45.9023 552.558 46.0695L530.058 59.1945C529.775 59.3596 529.54 59.596 529.377 59.8802C529.214 60.1644 529.128 60.4863 529.128 60.814C529.128 61.1417 529.214 61.4637 529.377 61.7478C529.54 62.032 529.775 62.2684 530.058 62.4336Z",
    fill: "url(#paint8_linear_2013_280)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M611.495 72.1329C611.495 103.956 585.531 129.759 553.496 129.759C521.461 129.759 495.497 103.956 495.497 72.1329C495.497 40.3095 521.461 14.5064 553.496 14.5064C585.531 14.5064 611.495 40.3095 611.495 72.1329Z",
    stroke: "url(#paint9_linear_2013_280)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M616.135 72.064C616.135 106.434 588.093 134.301 553.496 134.301C518.898 134.301 490.857 106.434 490.857 72.064C490.857 37.6942 518.898 9.82684 553.496 9.82684C588.093 9.82684 616.135 37.6942 616.135 72.064Z",
    stroke: "url(#paint10_linear_2013_280)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M620.775 71.9952C620.775 108.911 590.656 138.843 553.496 138.843C516.336 138.843 486.216 108.911 486.216 71.9952C486.216 35.079 516.336 5.14739 553.496 5.14739C590.656 5.14739 620.775 35.079 620.775 71.9952Z",
    stroke: "url(#paint11_linear_2013_280)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M625.415 71.9265C625.415 111.389 593.219 143.385 553.496 143.385C513.773 143.385 481.576 111.389 481.576 71.9265C481.576 32.4638 513.773 0.467949 553.496 0.467949C593.219 0.467949 625.415 32.4638 625.415 71.9265Z",
    stroke: "url(#paint12_linear_2013_280)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2013_280",
    x1: 885.5,
    y1: 75,
    x2: 885.5,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2013_280",
    x1: 666.5,
    y1: 75,
    x2: 666.5,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2013_280",
    x1: 445.5,
    y1: 75,
    x2: 445.5,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2013_280",
    x1: 222.5,
    y1: 75,
    x2: 222.5,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2013_280",
    x1: 553.5,
    y1: 75,
    x2: 553.5,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2013_280",
    x1: 553.496,
    y1: 16.8461,
    x2: 553.496,
    y2: 127.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8547F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2013_280",
    x1: 553.561,
    y1: 81.4266,
    x2: 553.561,
    y2: 98.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2013_280",
    x1: 553.561,
    y1: 70.1766,
    x2: 553.561,
    y2: 87.0638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2013_280",
    x1: 553.503,
    y1: 45.8142,
    x2: 553.503,
    y2: 75.8138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2013_280",
    x1: 495.029,
    y1: 72.1329,
    x2: 609.615,
    y2: 72.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2013_280",
    x1: 490.389,
    y1: 72.064,
    x2: 614.069,
    y2: 72.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2013_280",
    x1: 485.749,
    y1: 71.9952,
    x2: 618.523,
    y2: 71.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2013_280",
    x1: 481.108,
    y1: 71.9265,
    x2: 622.977,
    y2: 71.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(523.496 42.064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToursImg);
export default __webpack_public_path__ + "static/media/Tours-img.6a75ddc5d4cc60ef2a635e648b7b7ef9.svg";
export { ForwardRef as ReactComponent };